module.exports = __webpack_public_path__ + "media/fedex-video1.3a0d8f3b.mp4";